import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';

// Using the config provided in your original source
const firebaseConfig = {
  apiKey: "AIzaSyBL0vnNLcTafs9tPwARv7x1Xp9miM-9pLs",
  authDomain: "pod-designer-app.firebaseapp.com",
  projectId: "pod-designer-app",
  storageBucket: "pod-designer-app.firebasestorage.app",
  messagingSenderId: "244446110654",
  appId: "1:244446110654:web:dc7c32b1c1f1ffa9128fef"
};

// Cast to any to avoid strict TypeScript errors with compat library properties like .apps, .app(), .auth
const firebaseCompat = firebase as any;

// Initialize Firebase (check for existing app to prevent re-initialization errors)
const app = !firebaseCompat.apps.length ? firebaseCompat.initializeApp(firebaseConfig) : firebaseCompat.app();

export const auth = app.auth();
export const db = app.firestore();
export const googleProvider = new firebaseCompat.auth.GoogleAuthProvider();